import { call, put, takeLatest } from 'redux-saga/effects';

import {
  LOADING_DATA_START,
  LOADING_DATA_FINISHED,
} from '../reducers/loading.reducer';

import {
  SHARES_FETCH,
  SHARES_FETCH_SUCCESS,
  SHARES_FETCH_FAILURE,
  SHARES_ADD,
  SHARES_ADD_SUCCESS,
  SHARES_ADD_FAILURE,
  SHARES_EDIT,
  SHARES_EDIT_FAILURE,
  SHARES_EDIT_SUCCESS,
  SHARES_DELETE,
  SHARES_DELETE_SUCCESS,
  SHARES_REFRESH,
  SHARES_ADD_PERSONAL,
  SHARES_TOKEN_REFRESH,
  SHARES_TOKEN_REFRESH_FAILURE,
  SHARES_TOKEN_REFRESH_SUCCESS,
} from '../reducers/shares.reducer';
import { handleError } from './helper';
import { shareApi } from '../services';
import { showNotification } from '../helpers/notification';

function* fetchSharesRequest({ payload: { id } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    const { data } = yield call(shareApi.fetchBookletShares, { id });
    yield put({ type: SHARES_FETCH_SUCCESS, payload: data });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: SHARES_FETCH_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* addShareRequest({ payload: { share, id } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    const { data } = yield call(shareApi.createNewShare, { share, id });
    yield put({ type: SHARES_ADD_SUCCESS, payload: data });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: SHARES_ADD_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* addPersonalShareRequest({ payload: { share, id } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    const { data } = yield call(shareApi.createNewPersonalShare, {
      id,
      share,
    });
    yield put({ type: SHARES_ADD_SUCCESS, payload: data });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: SHARES_ADD_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* editShareRequest({ payload: { share, id } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    const { data } = yield call(shareApi.editShare, { share, id });
    yield put({ type: SHARES_EDIT_SUCCESS, payload: data });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: SHARES_EDIT_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* deleteShareRequest({ payload: { bookletId, shareId } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    yield call(shareApi.deleteShare, { bookletId, shareId });
    yield put({ type: SHARES_DELETE_SUCCESS, payload: { id: shareId } });
  } catch (error) {
    const message = yield* handleError(
      error,
      'Deletion of booklet share link failed.'
    );
    showNotification(message);
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* refreshShareRequest({ payload: { bookletId, shareId } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    const { data } = yield call(shareApi.refreshShare, { bookletId, shareId });
    yield put({ type: SHARES_EDIT_SUCCESS, payload: data });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: SHARES_EDIT_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* refreshPresentationShareTokenRequest({ payload: { id } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    const { data } = yield call(shareApi.refreshPresentationShareToken, { id });
    yield put({ type: SHARES_TOKEN_REFRESH_SUCCESS, payload: data });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: SHARES_TOKEN_REFRESH_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

export function* addPersonalShare() {
  yield takeLatest(SHARES_ADD_PERSONAL, addPersonalShareRequest);
}

export function* fetchShares() {
  yield takeLatest(SHARES_FETCH, fetchSharesRequest);
}

export function* addShare() {
  yield takeLatest(SHARES_ADD, addShareRequest);
}

export function* editShare() {
  yield takeLatest(SHARES_EDIT, editShareRequest);
}

export function* deleteShare() {
  yield takeLatest(SHARES_DELETE, deleteShareRequest);
}

export function* refreshShare() {
  yield takeLatest(SHARES_REFRESH, refreshShareRequest);
}

export function* refreshPresentationShareToken() {
  yield takeLatest(SHARES_TOKEN_REFRESH, refreshPresentationShareTokenRequest);
}



// WEBPACK FOOTER //
// ./src/sagas/shares.saga.js